// 风向转换
export const directionTransition = (windDeg) => {
  if (/^[\u4E00-\u9FA5\uF900-\uFA2D]+$/.test(windDeg)){
    return windDeg
  }
  if (windDeg) {
    if (windDeg <= 22.25 || windDeg > 337.75) {
      return '北风'
    } else if (windDeg > 22.25 && windDeg <= 67.25) {
      return '东北风'
    } else if (windDeg > 67.25 && windDeg <= 112.25) {
      return '东风'
    } else if (windDeg > 112.25 && windDeg <= 157.25) {
      return '东南风'
    } else if (windDeg > 157.25 && windDeg <= 202.25) {
      return '南风'
    } else if (windDeg > 202.25 && windDeg <= 247.25) {
      return '西南风'
    } else if (windDeg > 247.25 && windDeg <= 292.25) {
      return '西风'
    } else if (windDeg > 292.25 && windDeg <= 337.25) {
      return '西北风'
    } else {
      return '--'
    }
  } else {
    return '--'
  }
}

// 判断某个元素是否在数组中
export const isInArray = (arr, value) => {
  for (let i = 0; i < arr.length; i++) {
    if (value === arr[i]) {
      return true
    }
  }
  return false
}

// 判断某个元素是否在数组中 map: 地图，list：电子围栏数组，style：样式，传null时用默认，clickAction：点击事件监听，没有传null
export const drawPolygon = (map, list, style, clickAction) => {
  if (list && list.length > 0) {
    const _fence = []
    const ploygons = []
    list.forEach(item => {
      if (!isInArray(_fence, item.fenceCode)) {
        _fence.push(item.fenceCode)
      }
    })
    _fence.forEach(fItem => {
      const path = []
      list.forEach(pItem => {
        if (fItem === pItem.fenceCode) {
          path.push(new AMap.LngLat(pItem.longitude, pItem.latitude))
        }
      })
      // eslint-disable-next-line multiline-ternary
      const polygonStyle = style ? { ...style } : {
        fillColor: 'rgb(54, 203, 203)', // 背景色
        fillOpacity: 0.3, // 背景透明
        strokeWeight: 4, // 线条宽度
        strokeColor: 'rgba(54, 203, 203, 1)', // 线条色
        clickable: true // 是否可点击
      }
      const polygon = new AMap.Polygon({
        map: map,
        path: path,
        ...polygonStyle,
        extData: { fenceCode: fItem || '' }
      })
      map && map.add(polygon)
      // 点击电子围栏方法
      if (clickAction) {
        polygon.on('click', clickAction)
      }
      ploygons.push(polygon)
    })
    console.log('drawPolygon Function')
    // 缩放地图到合适的视野级别
    map && map.setFitView(ploygons)
    return ploygons
  } else {
    return []
  }
}

// 获取uuid
export const getUUID = () => {
  // 32长度
  const len = 32
  // 16进制
  const radix = 16
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  const uuid = []
  let i
  for (i = 0; i < len; i++) {
    uuid[i] = chars[0 | Math.random() * radix]
  }
  return uuid.join('')
}

// 根据身份证号计算年龄与性别
export const analyzeIDCard = (IDCard) => {
  const sexAndAge = {
    sex: '',
    age: ''
  }

  // 获取身份证号码
  const userCard = IDCard
  // 如果身份证号码为undefind则返回空
  if (userCard && (userCard.length === 15 || userCard.length === 18)) {
    const startNum = userCard.length === 15 ? 8 : 10
    // 获取性别 '0': 男, '1': 女
    if (parseInt(userCard.substr(startNum + 6, 1)) % 2 === 1) {
      sexAndAge.sex = '0'
    } else {
      sexAndAge.sex = '1'
    }

    // 获取出生年月日
    const yearBirth = Number(userCard.substring(6, startNum))
    const monthBirth = Number(userCard.substring(startNum, startNum + 2))
    const dayBirth = Number(userCard.substring(startNum + 2, startNum + 4))
    // 获取当前年月日并计算年龄
    const myDate = new Date()
    const monthNow = Number(myDate.getMonth() + 1)
    const dayNow = Number(myDate.getDay())
    let age = Number(myDate.getFullYear() - yearBirth)
    if (monthNow < monthBirth || (monthNow === monthBirth && dayNow < dayBirth)) {
      age--
    }
    // 得到年龄
    sexAndAge.age = age.toString()
  }

  // 返回性别和年龄
  return sexAndAge
}

// 转换为yyyy-MM-dd HH-mm-ss
export const timeFormat = (timestamp) => {
  if (timestamp && timestamp !== '' && timestamp !== null) {
    timestamp = typeof timestamp === 'number' ? timestamp : parseInt(timestamp)
    const time = new Date(timestamp)
    const year = time.getFullYear()
    const month = time.getMonth() + 1
    const date = time.getDate()
    const hours = time.getHours()
    const minutes = time.getMinutes()
    const seconds = time.getSeconds()
    return year + '-' + addZero(month) + '-' + addZero(date) + ' ' + addZero(hours) + ':' + addZero(minutes) + ':' + addZero(seconds)
  } else {
    return ''
  }
}

// 补0
function addZero (m) {
  return m < 10 ? '0' + m : m
}

// 转换为yyyy-MM-dd
export const dayFormat = (timestamp) => {
  if (timestamp && timestamp !== '' && timestamp !== null) {
    timestamp = typeof timestamp === 'number' ? timestamp : parseInt(timestamp)
    const time = new Date(timestamp)
    const year = time.getFullYear()
    const month = time.getMonth() + 1
    const date = time.getDate()
    return year + '-' + addZero(month) + '-' + addZero(date)
  } else {
    return ''
  }
}

// 随机获取颜色
export const colorRandom = () => {
  let color = '#'
  const arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f']
  for (let i = 0; i < 6; i++) {
    const num = parseInt((Math.random() * 16).toString())
    color += arr[num]
  }
  return color
}
